import React from "react";
import ACLStore from "lib/aclStore";
import { parseConfigurationValue } from "Utils";
import _ from "lodash";
import ACLStorage from "lib/aclService";
import CurriculumProgramLogo from "AppComponents/CurriculumProgramLogo";
import { ACADEMIC_SETUP_VIEW_PERM } from "Constants/permissionConstants";

import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";

export const getVisibilityOfProgramDynamicNode = ({
  params,
  node,
  configuration,
}) => {
  const { curriculumConfig } = params;

  const { curriculumProgramId } = node;

  const configurationObjectByProgramAndNode = _.get(curriculumConfig, [
    curriculumProgramId,
    configuration,
  ]);

  return configurationObjectByProgramAndNode
    ? parseConfigurationValue(configurationObjectByProgramAndNode)
    : ACLStore.can(configuration);
};

export const getDynamicCurriculumRootNode = ({ params, node }) => {
  const { curriculumPrograms } = params;

  const curriculumProgram = _.find(curriculumPrograms, {
    id: node.curriculumProgramId,
  });

  const updatedNode = {
    ...node,
    label: curriculumProgram.label,
  };

  return [updatedNode];
};

export const getDynamicAcademicProgramRootNode = ({ params, node }) => {
  const { academicCurriculumPrograms } = params;

  const curriculumProgram = _.find(academicCurriculumPrograms, {
    id: node.curriculumProgramId,
  });

  const updatedNode = {
    ...node,
    label: curriculumProgram.label,
    route: `academic/${curriculumProgram.id}`,
    curriculumProgramId: curriculumProgram.id,
    prefix: (
      <CurriculumProgramLogo curriculumProgramId={curriculumProgram.id} />
    ),
  };

  return [updatedNode];
};

export const getCanUserAccessAcademicSetup = ({
  curriculumProgramId,
  userCurriculumPrograms = [],
  isAcademicProgramConsumptionEnabled = false,
}) => {
  if (isAcademicProgramConsumptionEnabled) {
    return ACLStorage.getModuleSettingsValue(ACADEMIC_SETUP_VIEW_PERM);
  }

  const hasAccessToCurriculum = _.some(userCurriculumPrograms, {
    id: curriculumProgramId,
  });
  return (
    hasAccessToCurriculum &&
    getIsAcademicSetupEnabledForCurriculum({ curriculumProgramId })
  );
};

export const getIsAcademicSetupEnabledForCurriculum = ({
  curriculumProgramId,
}) => {
  return ACLStorage.getModuleSettingsValueByContext(ACADEMIC_SETUP_VIEW_PERM, [
    { entityType: "CURRICULUM_PROGRAM", entityId: curriculumProgramId },
  ]);
};

export const getCourseClassSettingsLabel = ({ curriculumProgrammeList, t }) => {
  const isAllSchoolWithLearningCoursesEnabled = _.every(
    curriculumProgrammeList,
    school => {
      const isLearningCourseEnabled = getIsLearningCoursesEnabled({
        curriculumProgramId: school.id,
      });
      return isLearningCourseEnabled;
    }
  );

  if (isAllSchoolWithLearningCoursesEnabled) {
    return t("common:course_and_class_module_settings");
  }

  return t("common:class_module_settings");
};
